<template>
  <!-- place -->
  <div>
    <div v-show="!hidden" class="formGroup isRequired mt15">
      <label class="label toCapitalize notranslate">{{locale.reservation_place}}</label>
      <select class="input" v-model="place" @change="selectPlace">
        <option value="" disabled class="notranslate toCapitalize">{{locale.select_place}}</option>
        <option
          v-for="p in placeInfo"
          :key="p.placeId"
          :value="p.placeId"
          :disabled="p.disabled">
          {{p.name[lang]}}
        </option>
      </select>
    </div>
    <div v-if="isSelectable && current" class="statusMessage mt10">
      <span>
        {{locale.reservation_status}}: {{current.current}}/{{current.count}}
        <i v-if="isStaff && overbooking <= 0">Overbooking</i>
      </span>
    </div>
  </div>
  <!-- //place -->
</template>

<script>
import moment from 'moment/moment'
import regExp from '@/common/regExp'
import Summary from '@/components/Reservation/Summary'
import SeatMap from '@/components/Reservation/SeatMap'

export default {
  name: 'ReservationFormPlace',
  props: [
    'lang',
    'ln',
    'locale',
    'info',
    'roomKey',
    'rid',
    'isPublic',
    'placeInfo',
    'isSelectable',
    'isStaff',
    'seatCount'
  ],
  components: {
    Summary,
    SeatMap
  },
  computed: {
    current () {
      const list = this.placeInfo
      return list && list.find(x => x.placeId === this.place)
    },
    overbooking () {
      const count = this.current && this.current.count
      const current = this.current && this.current.current
      return parseInt(count) - parseInt(current)
    }
  },
  watch: {
    placeInfo: {
      deep: true,
      handler () {
        this.autoFull()
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.autoFull()
    })
  },
  beforeDestroy () {
    this.place = null
    this.selectPlace()
  },
  data () {
    return {
      hidden: false,
      place: ''
    }
  },
  methods: {
    autoFull () {
      if (this.isSelectable && this.placeInfo && this.placeInfo.length === 1) {
        this.place = this.placeInfo[0].placeId
        this.selectPlace()
        this.hidden = true
      } else {
        this.hidden = false
      }
    },
    selectPlace () {
      this.$emit('setPlace', this.place)
    }
  }
}
</script>

<style lang="scss" scoped>
.statusMessage {
  span {
    display: inline-block;
    position: relative;
    padding: 4px 10px;
    font-size: 0.85em;
    color: $color-white;
    white-space: nowrap;
    border-radius: 50px;
    background-color: $color-green;
    i {
      margin-left: 2px;
      padding: 0 4px;
      color: $color-red;
      font-size: 0.85em;
      border-radius: 4px;
      background-color: $color-white;
      opacity: 0.9;
    }
  }
}
</style>
